export default __webpack_public_path__ + "static/media/bannerBig5.b05f8ce3.png";